import { EditOutline30Icon } from "@vygruppen/spor-icon-react";
import { VehicleBooking } from "features/CenterContent/VehicleDetails/ReserveAlternativeTransportDetails/VehicleBooking";
import { VehicleSummary } from "features/CenterContent/VehicleDetails/shared/VehicleSummary";
import { vehicleTypeToIcon } from "features/CenterContent/VehicleDetails/shared/utils";
import AddVehicle from "features/VehicleSidebar/VehicleList/AddVehicles/AddVehicle";
import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, HStack, Text } from "shared/components/Spor";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";
import styled from "styled-components";

type Props = {
  reserveAlternativeTransport: ReserveAlternativeTransport;
};

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 1;
`;

export const BackupVehicleInfo: FC<Props> = ({
  reserveAlternativeTransport,
}) => {
  const location = useLocation();
  const {
    baseStopName,
    workShiftId,
    shiftStartTime,
    operatorName,
    shiftEndTime,
    type,
    driverPhoneNumber,
    logs,
  } = reserveAlternativeTransport;
  const [_Icon, _iconTitle] = vehicleTypeToIcon.get(type)!;

  const { vehicleTitle } = location.state || { vehicleTitle: "Beredskap" };

  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <InfoWrapper>
      <VehicleSummary
        vehicleInfo={operatorName}
        title={vehicleTitle}
        type={type}
        subTitle={workShiftId}
        route={baseStopName}
        startTime={shiftStartTime}
        endTime={shiftEndTime}
        vehicleStatus={null}
        logs={logs ?? []}
        driverPhoneNumber={driverPhoneNumber}
      />
      <HStack role="group" mt="12px">
        <Button
          variant="tertiary"
          size="sm"
          onClick={() => setShowEditModal(true)}
          leftIcon={<EditOutline30Icon />}
        >
          <Text>Rediger</Text>
        </Button>
        <VehicleBooking vehicle={reserveAlternativeTransport} />
      </HStack>
      {showEditModal && (
        <AddVehicle
          editVehicle={reserveAlternativeTransport}
          isReserveBusTabSelected={false}
          closeModal={() => setShowEditModal(false)}
        />
      )}
    </InfoWrapper>
  );
};
